module.exports = __webpack_public_path__ + "static/media/other-tools.d6ea3209.webp";